import moment from 'moment'
import React from 'react'
import {FilterPanel, Section} from './ARStyledComponents'
import {ColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import CalendarForReservation from '../../../components/CalendarForReservation'
import {DayModifiers} from 'react-day-picker'

interface Props {
    today: moment.Moment
    selectedDay?: moment.Moment
    holidays: string[]
    onSelectDay: (day: moment.Moment) => void
}

export const DateFilter: React.FC<Props> = props => {
    const {today, selectedDay, onSelectDay, holidays} = props
    return <FilterPanel>
        <Section>利用希望日</Section>
        <ColumnFlexContainer>
            <CalendarForReservation
                today={today.toDate()}
                holidays={holidays}
                selectedDay={selectedDay ? selectedDay.toDate() : undefined}
                onDayClick={(day: Date,
                             modifiers: DayModifiers,
                             e: React.MouseEvent,
                ) => {
                    onSelectDay(moment(day))
                }}
            />
        </ColumnFlexContainer>
    </FilterPanel>
}
